import { createEffect, createEvent, createStore, sample } from 'effector'
import {
	updateUserLangQuery,
	updateUserQuery,
	userDeleteQuery,
	userQuery,
	createAnonymousPaymentQuery,
} from "./queries";
import { 
    checkProfessionQuery,
    updateProfessionQuery
  } from './queries';
  
// Types
export type SupportedLanguage = 'EN' | 'SV' | 'ES' | 'FR' | 'DE' | 'IT' | 'PT' | 'RU' | 'JA';

// User effects and stores
export const userFx = createEffect(userQuery)
export const $user = createStore<any>({}).on(
    userFx.doneData,
    (_store, res) => {
		console.log("[$user store] Updating user store with:", res);
		console.log("[$user store] User subscription:", res?.subscription);
		return res;
	}
)
export const createAnonymousPaymentFx = createEffect(createAnonymousPaymentQuery)

// for google tag manager (facebook)
// @ts-ignore
window["userStore"] = $user;

export const userHandler = createEvent<any | null>()

sample({
    clock: userFx.doneData,
    fn: (clk: any) => clk,
    target: userHandler,
})

export const userDeleteFx = createEffect(userDeleteQuery)
export const $userDelete = createStore<any>(null)
export const userDeleteHandler = createEvent<any>()

sample({
    target: userDeleteHandler,
    fn: (clk) => clk,
    clock: userDeleteFx.doneData,
})

export const updateUserFx = createEffect(updateUserQuery)
export const $updateUser = createStore<any>(null).on(
    updateUserFx.doneData,
    (_store, res) => res
)
export const updateUserEvent = createEvent()

sample({
    fn: (clk: any) => clk,
    target: updateUserEvent,
    clock: updateUserFx.doneData,
})

// Language related stores and events
export const $userLanguage = createStore<SupportedLanguage>('EN')
export const userLanaguageEvent = createEvent<SupportedLanguage>()

sample({
    clock: userLanaguageEvent,
    target: $userLanguage,
})

export const $updateUserLang = createStore<any>({})
export const updateUserLangFx = createEffect(updateUserLangQuery)
export const updateUserLangEvent = createEvent()

sample({
    fn: (clk: any) => clk,
    target: updateUserLangEvent,
    clock: updateUserLangFx.doneData,
})

// 1. Определение типов
// 1. Определение типов
// 1. Определение типов
export interface ProfessionCheckResponse {
    hasProfession: boolean;
    profession?: string | null;
  }
  
  // 2. Создание эффектов
  // Эффект для проверки профессии
  export const checkProfessionFx = createEffect<void, ProfessionCheckResponse, Error>(
    async () => {
      return await checkProfessionQuery();
    }
  );
  
  // Эффект для обновления профессии
  export const updateProfessionFx = createEffect<string, void, Error>(
    async (profession: string) => {
      await updateProfessionQuery(profession);
    }
  );
  
  // 3. Создание событий
  export const checkProfessionEvent = createEvent();
  export const updateProfessionEvent = createEvent<string>();
  
  // 4. Создание сторов
  export const $hasProfession = createStore<boolean>(false)
    .on(checkProfessionFx.doneData, (_, response) => response.hasProfession);
  
  export const $profession = createStore<string | null>(null)
    .on(checkProfessionFx.doneData, (_, response) => response.profession || null);
  
  export const $professionCheckError = createStore<string | null>(null)
    .on(checkProfessionFx.failData, (_, error) => error.message)
    .reset(checkProfessionFx.done);
  
  export const $professionUpdateError = createStore<string | null>(null)
    .on(updateProfessionFx.failData, (_, error) => error.message)
    .reset(updateProfessionFx.done);
  
  export const $isCheckingProfession = createStore<boolean>(false)
    .on(checkProfessionFx.pending, (_, pending) => pending);
  
  export const $isUpdatingProfession = createStore<boolean>(false)
    .on(updateProfessionFx.pending, (_, pending) => pending);
  
  // 5. Связывание событий и эффектов
  sample({
    clock: checkProfessionEvent,
    target: checkProfessionFx
  });
  
  sample({
    clock: updateProfessionEvent,
    target: updateProfessionFx
  });
  
  // 6. Дополнительные обработки
  // Обновляем профессию в сторе после успешного обновления
  sample({
    clock: updateProfessionFx.done,
    source: updateProfessionFx.done.map(({ params }) => params),
    target: $profession
  });
  
  // Автоматическая проверка профессии после обновления
  sample({
    clock: updateProfessionFx.done,
    target: checkProfessionEvent
  });